/*
 * Public API Surface of pepperi-lib/dialog
 */
export * from './dialog.module';
export * from './dialog.component';
